export const addinDomain=`https://msword.portant.co`
// Portant web app. Appending `?new=true` opens the "create workflow" flow on load.
export const webAppUrl = `https://app.portant.co`
export const createWorkflowUrl = `${webAppUrl}/workflows?new=true`
// export const clientId=`d14f6ac4-0ea8-4f25-8213-16c0df300efa`
export const clientId=`19d9f798-2dfb-479f-8a62-74a0afcfdfea`
 export const loginUrl = "https://login.microsoftonline.com/common/oauth2/v2.0/authorize" +
    "?client_id=d14f6ac4-0ea8-4f25-8213-16c0df300efa" +
    "&response_type=code" +
    `&redirect_uri=${addinDomain}/assets/Redirect.html` +
    "&scope=User.Read offline_access" +
    "&response_mode=query";
